import { useQuery } from '@tanstack/react-query';

import { useFeatureApi } from '../../api';
import { featureKeys } from '../../keys';
import { FeatureFlags } from '../flags.types';
import { FeatureFlagCheckResponse } from './types';

const useShowFeatureStatus = ({
  flagId,
  causeId,
  _enabled = true,
}: {
  flagId?: FeatureFlags;
  causeId?: string;
  _enabled?: boolean;
}) => {
  const FeatureApi = useFeatureApi();

  const getFeatureFlag = async () => {
    const searchParams = new URLSearchParams();
    if (causeId) {
      searchParams.set('cause_id', causeId);
    }
    if (flagId) {
      searchParams.set('uuid', flagId);
    }
    const { data } = await FeatureApi.get<FeatureFlagCheckResponse>(
      `/flags/check?${searchParams.toString()}`
    );
    return data;
  };

  const queryKey = flagId && causeId ? featureKeys.flags.id(flagId).check.id(causeId).detail : [];

  return useQuery({
    queryKey,
    queryFn: getFeatureFlag,
    enabled: !!flagId && _enabled && !!causeId,
  });
};

export { useShowFeatureStatus };
